export default __webpack_public_path__ + "static/media/bg-pattern-pricing.44408ab5.svg";